import { render, staticRenderFns } from "./ProviderSelect.vue?vue&type=template&id=7b4fdb5f"
import script from "./ProviderSelect.vue?vue&type=script&lang=ts"
export * from "./ProviderSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports